import { useRouter } from 'next/router';

import { getLibraryIdFromPath } from '~/utils/PathUtils';

export const useURLLibraryIdSelector = () => {
  const { asPath } = useRouter();
  return getLibraryIdFromPath(asPath);
};
